import { useState, useEffect, useCallback } from "react";
import { getPromotions } from "../../api";
import { usePromotionsQuery } from "../../hooks/usePromotionsQuery";
import { getLogger } from "@hoteltradergit/ht-telemetry-ui-lib";

export const usePromotionsTableData = ({ propertyId, isGetPromosList }) => {
  const [promotions, setPromotions] = useState([]);
  const [pagable, setPagable] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    queryParams,
    searchInputValue,
    buildQueryString,
    handleFilterChange,
    handleSearchChange,
    handleSortChange,
    handlePageChange,
  } = usePromotionsQuery(propertyId);

  const fetchPromotions = useCallback(() => {
    if (!buildQueryString) return;

    setLoading(true);

    getPromotions(buildQueryString)
      .then((res) => {
        setPromotions(res?.data?.data?.content || []);
        setPagable({
          ...res.data.data.pageable,
          totalElements: res.data.data.totalElements,
          totalPages: res.data.data.totalPages,
        });
      })
      .catch((error) => {
        getLogger().error("usePromotionsTableData", {
          type: "Error",
          page_url: window.location.href,
          error_desc: "Failed to fetch promotions",
          error_stack: error?.stack ?? null,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [buildQueryString]);

  useEffect(() => {
    if (propertyId && isGetPromosList) {
      fetchPromotions();
    }
  }, [propertyId, isGetPromosList, fetchPromotions]);

  return {
    queryParams,
    searchInputValue,
    handleFilterChange,
    handleSearchChange,
    handleSortChange,
    handlePageChange,
    promotions,
    pagable,
    loading,
  };
};
